// SPDX-License-Identifier: GPL-3.0-only
// Copyright (C) 2026 Kyle Johnson

import React from 'react';
import { useTranslation } from 'react-i18next';

interface ReconcileMarkProps {
  state: 'n' | 'c' | 'y';
  size?: 'sm' | 'md';
  interactive?: boolean;
  onClick?: () => void;
}

export function ReconcileMark({ state, size = 'md', interactive = false, onClick }: ReconcileMarkProps) {
  const { t } = useTranslation(['accounting', 'transactions', 'common', 'errors']);
  const dim = size === 'sm' ? 14 : 16;

  const tooltips = {
    n: t('reconcileMark.notReconciled'),
    c: t('reconcileMark.clearedPending'),
    y: t('reconcileMark.reconciled'),
  };

  const content = state === 'y'
    ? <span style={{ color: '#3D9970', fontSize: dim, lineHeight: 1 }}>●</span>
    : state === 'c'
    ? <span style={{ color: '#7B7F9E', fontSize: dim, lineHeight: 1 }}>◐</span>
    : null;

  return (
    <span
      title={tooltips[state]}
      onClick={interactive ? onClick : undefined}
      style={{
        display: 'inline-flex',
        width: dim,
        height: dim,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: interactive ? 'pointer' : 'default',
        flexShrink: 0,
      }}
    >
      {content}
    </span>
  );
}
